const coverImage =
  "https://readdy.ai/api/search-image?query=towering-editorial-collage-of-vintage-newspaper-clippings-scattered-documents-and-paper-stacks-around-a-large-magnifying-glass-hovering-over-an-unfurled-timeline-ribbon-with-dots-lines-and-branch-nodes-editorial-flat-vector-illustration-on-warm-cream-paper-background-with-terracotta-red-and-deep-melon-green-accent-palette-thin-elegant-line-art-with-subtle-paper-grain-magazine-cover-aesthetic-soft-minimal-composition-generous-negative-space-no-text-no-watermark&width=720&height=940&seq=gw51-hero-cover&orientation=portrait";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -right-16 top-8 select-none font-heading text-[16rem] font-black leading-none text-foreground-100/40 md:-right-4 md:text-[24rem]">
        瓜
      </div>

      <div className="relative mx-auto grid max-w-[1240px] items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
        <div className="relative">
          <div className="mb-5 flex items-center gap-3 text-xs text-foreground-600 md:text-sm">
            <span className="inline-flex items-center gap-2 whitespace-nowrap">
              <i className="ri-file-list-3-line h-4 w-4 text-primary-600" />
              事件复盘 · 专栏
            </span>
            <span className="h-4 w-px bg-foreground-200" />
            <span className="whitespace-nowrap text-foreground-500">Vol. 12 · 2026.09</span>
          </div>

          <h1 className="font-heading text-4xl font-black leading-[1.14] tracking-tight text-foreground-950 md:text-6xl">
            这一件风波，
            <br />
            别只刷到
            <span className="relative inline-block text-primary-600">
              一半
              <span className="absolute -bottom-1.5 left-0 h-1 w-full rounded bg-primary-200/70 md:-bottom-2.5" />
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-8 text-foreground-700 md:text-lg">
            从一句深夜感慨，到百万弹幕对线——<strong className="font-semibold text-foreground-950">来龙去脉</strong>都在这里。五1吃瓜把
            <strong className="font-semibold text-foreground-950">完整过程</strong>按时间线一条条梳理，深扒
            <strong className="font-semibold text-foreground-950">内幕与幕后细节</strong>，关键节点不错过。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#laiqu"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-base font-medium text-background-50 transition hover:bg-primary-600"
            >
              一条龙看懂全貌
              <i className="ri-arrow-down-line h-4 w-4" />
            </a>
            <a
              href="#zhuanti"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-6 py-3 text-base text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-sparkling-2-line h-4 w-4" />
              先看速览
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 text-xs text-foreground-500 md:text-sm">
            <span className="inline-flex items-center gap-2">
              <i className="ri-time-line h-4 w-4 text-accent-600" />
              更新至 2026.09.06
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="ri-timeline-view h-4 w-4 text-accent-600" />
              全文约 6800 字
            </span>
            <span className="inline-flex items-center gap-2">
              <i className="ri-eye-line h-4 w-4 text-accent-600" />
              本期已深读 12.4w 次
            </span>
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-[340px] md:max-w-[380px]">
          <figure className="relative overflow-hidden rounded-t-[1.5rem] rounded-b-md border border-background-200 bg-background-100">
            <div className="flex items-center justify-between border-b border-background-200 bg-background-50 px-4 py-2.5">
              <span className="font-heading text-sm font-bold tracking-wide text-foreground-950">五1吃瓜 · 事件档案</span>
              <span className="flex items-center gap-1.5 text-[11px] text-foreground-500">
                <i className="ri-verified-badge-fill h-4 w-4 text-accent-600" />
                逐条核实
              </span>
            </div>
            <img
              src={coverImage}
              alt="五1吃瓜事件详情与来龙去脉档案封面图"
              className="h-[300px] w-full object-cover md:h-[360px]"
            />
            <figcaption className="space-y-1.5 px-5 py-4">
              <p className="font-heading text-base font-bold leading-snug text-foreground-950">
                「解约风波」全时间线
              </p>
              <p className="text-xs leading-5 text-foreground-600">
                深扒内幕 · 关键节点 · 幕后细节 —— 本期档案
              </p>
              <div className="flex items-center gap-2 pt-1">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-[11px] text-accent-800">
                  <i className="ri-download-2-line h-3 w-3" /> 下载完整档案
                </span>
              </div>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}